<ion-item *ngIf="stringSearch" class="compact fullWidth" lines="none">
    <ion-icon slot="start" name="search"></ion-icon>
    <ion-label *ngIf="stringSearch.search" class="compactlabel" position="stacked">
        {{translationPrefix + '.name' | translate}}
    </ion-label>
    <ion-item lines="none" class="compact fullWidth">
        <ion-input class="compact" minlength=2 debounce=250
                   placeholder="{{translationPrefix +'.all' | translate}}"
                   [(ngModel)]="stringSearch.search" (ionChange)="dataChange()" (ionInput)="dataChange()"
                   (ionBlur)="dataChange()">
        </ion-input>
        <ion-icon *ngIf="stringSearch.search" slot="end" name="close"
                  (click)="clearSearch()">
        </ion-icon>
    </ion-item>
</ion-item>
